import { Loader2 } from 'lucide-react';
import { ReactNode, useEffect } from 'react';

import { refreshAccessToken } from '@/lib/apiClient';
import { useAppDispatch, useAppSelector } from '@/store';
import { setUnauthenticated } from '@/store/authSlice';
import { detectBrowserHint } from '@/utils/browserHint';

interface AuthBootstrapProps {
  children: ReactNode;
}

/**
 * On first load the access token lives only in memory, so it is gone after a
 * reload. We attempt a silent refresh using the httpOnly cookies before
 * rendering routes: a valid session logs the user straight in (no login page),
 * an invalid one falls through to the guards.
 */
const AuthBootstrap = ({ children }: AuthBootstrapProps) => {
  const dispatch = useAppDispatch();
  const status = useAppSelector((state) => state.auth.status);

  useEffect(() => {
    void detectBrowserHint();
    refreshAccessToken().catch(() => dispatch(setUnauthenticated()));
  }, [dispatch]);

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-brand" />
      </div>
    );
  }

  return children;
};

export default AuthBootstrap;
